import React from 'react';
const SvgExtractFailure = React.forwardRef((rest, ref) => {
  const props = { ...rest, ref };
  return (
    <svg width="1em" height="1em" viewBox="0 0 20 17" {...props}>
      <path
        d="M11.37 16.815h8.126V5.483h-2.207V13.16h-2.575v1.28h-.552V11.88h.552v.73h2.023V5.483h-2.759v-2.01h-3.653l-.475 1.27 2.216 4.441-1.35 2.961.654 4.67zm-.625 0H0V0h7.403l-.317 2.924H2.207V13.16H8.613l2.132 3.655zM11.625 0h2.353v2.924H10.53L11.625 0zM8.293 12.611H2.759V8.408H4.23v-.549H2.76V3.473h4.267l-.137 1.27 1.729 3.116H7.54v.549h1.38l.432.776-1.332 2.961.272.466zM14.53 0l4.966 4.935H14.53V0z"
        fill="#E4E4E3"
        fillRule="nonzero"
      />
    </svg>
  );
});
export default SvgExtractFailure;
SvgExtractFailure.iconName = 'extract-failure';
SvgExtractFailure.displayName = 'SvgExtractFailure';
